import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { Colaborador } from "../../../services/Colaborador";
import {
  IColaboradorFormRHF,
  IColaboradorForm,
} from "../../../types/colaborador";
import { useNavigate } from "react-router-dom";

export const useCollaboratorRegister = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();

  function onSubmit(data: IColaboradorFormRHF) {
    setIsLoad(true);

    const PAYLOAD: IColaboradorForm = {
      ...data,
      perfis: data.perfis.map((i) => i?.value),
      ativo: false
    };

    Colaborador.post(PAYLOAD)
      .then(() => {
        toast.success("Colaborador cadastrado com sucesso");
        setTimeout(() => {
          navigate("/configuracoes/colaboradores");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }
  return { onSubmit };
};
